/**
 * RFC 4180–style CSV: comma delimiter, double-quoted fields, "" for literal quote,
 * newlines allowed inside quoted fields.
 */
export function parseCsv(text: string, delimiter = ","): string[][] {
  if (!text) return [];

  const rows: string[][] = [];
  let row: string[] = [];
  let field = "";
  let i = 0;
  let inQuotes = false;
  const len = text.length;

  while (i < len) {
    const c = text[i]!;
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i += 2;
          continue;
        }
        inQuotes = false;
        i += 1;
        continue;
      }
      field += c;
      i += 1;
      continue;
    }

    if (c === '"') {
      inQuotes = true;
      i += 1;
      continue;
    }
    if (c === delimiter) {
      row.push(field);
      field = "";
      i += 1;
      continue;
    }
    if (c === "\r") {
      i += 1;
      continue;
    }
    if (c === "\n") {
      row.push(field);
      rows.push(row);
      row = [];
      field = "";
      i += 1;
      continue;
    }
    field += c;
    i += 1;
  }

  row.push(field);
  rows.push(row);

  return rows;
}

/** Pad ragged rows so every row has the same column count (max seen). */
export function padCsvRows(rows: string[][]): string[][] {
  if (rows.length === 0) return rows;
  const max = rows.reduce((m, r) => Math.max(m, r.length), 0);
  return rows.map((r) => {
    if (r.length >= max) return r;
    return [...r, ...Array(max - r.length).fill("")];
  });
}
